// Central place for the BUSINESS contact info.
// Change here → reflects everywhere in the app.
export const BUSINESS_PHONE = "9467458749";
export const BUSINESS_EMAIL = "sales@thepataudi.com";
export const BUSINESS_WHATSAPP = "9467458749";                    // digits only
export const BUSINESS_WA_LINK = "https://wa.me/91" + "9467458749"; // full link

// Convenience helper: build a wa.me link with a prefilled message.
export function buildWhatsAppLink(message = "", number = BUSINESS_WHATSAPP) {
  const n = String(number).replace(/[^0-9]/g, "");
  const withCountry = n.startsWith("91") ? n : "91" + n;
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${withCountry}${encoded ? "?text=" + encoded : ""}`;
}

// Format a structured inquiry payload into a single WhatsApp message body.
export function formatInquiry({ type, name, phone, email, location, details, extra }) {
  const lines = ["*New Inquiry Received*", ""];
  if (type)     lines.push(`Type: ${type}`);
  if (name)     lines.push(`Name: ${name}`);
  if (phone)    lines.push(`Phone: ${phone}`);
  if (email)    lines.push(`Email: ${email}`);
  if (location) lines.push(`Location: ${location}`);
  if (extra && typeof extra === "object") {
    for (const [k, v] of Object.entries(extra)) {
      if (v === null || v === undefined || v === "") continue;
      lines.push(`${k}: ${v}`);
    }
  }
  if (details) lines.push("", "Message:", details);
  lines.push("", "— Sent from thepataudi.com");
  return lines.join("\n");
}
